module.exports = {"TXTWCL_N0_logo":{"id":"TXTWCL_N0_logo","defaultMessage":"{competitionName}-Logo"}}